import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import $ from "jquery";

const selectors = {
	header: '.c-header',
	notification: '.c-header-notification',
	wrapper: '.c-header__wrapper',
};

const classes = {
	// Add class names here if needed later
};

const module = {
	init() {
		gsap.registerPlugin(ScrollTrigger);

		const header = document.querySelector(selectors.header);
		const notification = document.querySelector(selectors.notification);
		const wrapper = document.querySelector(selectors.wrapper);

		let notificationPadding = 0;
		let notificationTop = 0;

		if (notification) {
			notificationPadding = 56; // Default padding for notification
			notificationTop = notification.getBoundingClientRect().top + window.scrollY + notificationPadding;
		}

		if (!header || !wrapper) {
			console.warn('Required elements are missing in the DOM.');
			return;
		}

		let lastScrollTop = window.scrollY;
		let isScrollingUp = false;
		let scrollTimeout;

		const minHeight = 0;
		const wrapperTop = wrapper.getBoundingClientRect().top + window.scrollY;
		const scrollDistance = wrapperTop - notificationTop + notificationPadding;

		//window.addEventListener('load', () => {
		//	ScrollTrigger.refresh();
		//});

		window.addEventListener('scroll', () => {
			const currentScrollTop = window.scrollY;

			// Ensure we only detect significant scroll changes
			if (Math.abs(currentScrollTop - lastScrollTop) > 5) { // Adjust the threshold as needed
				if (currentScrollTop < lastScrollTop) {
					// Scrolling up
					isScrollingUp = true;


					clearTimeout(scrollTimeout);

					scrollTimeout = setTimeout(() => {
						header.classList.remove('is-up');
						ScrollTrigger.refresh();
					}, 250);

				} else {
					// Scrolling down
					isScrollingUp = false;

					clearTimeout(scrollTimeout);

					scrollTimeout = setTimeout(() => {
						header.classList.add('is-up');
						ScrollTrigger.refresh();
					}, 250);

				}
			}

			lastScrollTop = currentScrollTop;
		});


		module._animateNotification({
			header,
			notification,
			wrapper,
			minHeight,
			scrollDistance,
			notificationPadding
		});
	},

	_animateNotification({ header, notification, wrapper, minHeight, scrollDistance, notificationPadding }) {
		gsap.to(notification, {
			height: 0,
			paddingTop: 0,
			paddingBottom: 0,
			ease: "none",
			scrollTrigger: {
				trigger: notification,
				start: "top top",
				end: `+=${scrollDistance}`,
				scrub: true,
			}
		});

		ScrollTrigger.create({
			trigger: header,
			start: "top top",

			onEnter: () => {
				header.classList.add('is-sticky');
				if (notification) {
					notification.style.borderBottom = "0";
				}
			},
			onLeaveBack: () => {
				header.classList.remove('is-sticky');
				if (notification) {
					notification.style.borderBottom = "1px solid #9991AE";
				}
			}
		});
	}
};

export { module as HeaderSticky };
